// The curated currency tables (SPEC §2.3, decisions Q-1, D-R8).
//
// CONTRACT (SPEC §2.10): backend parity tests read this file AS TEXT, because backends cannot
// import packages. Keep exactly three statements, each on ONE line, of the form
// `export const NAME = <JSON literal>;` — double-quoted strings, no comments inside a literal, no
// spread, no computed keys, no trailing commas, no Object.freeze, no `as const`, no wrapper call,
// and no other export in this file. currency.test.js runs the parity readers' regex against it.
//
// OFFERED_CURRENCIES: what an org may offer, USD first. MINOR_UNIT_EXCEPTIONS: decimals for every
// code that is not 2 (the 0-decimal codes are test-only, never offered). SYMBOLS: the only codes
// that render with a symbol; every other code renders with its ISO code as a prefix.
// The prettier-ignore lines keep `pnpm format` from re-quoting or wrapping the literals.
// prettier-ignore
export const OFFERED_CURRENCIES = ["USD","GBP","EUR","CAD","AUD","NZD","AED","SAR","QAR","KWD","BHD","OMR","JOD","INR","PKR","BDT"];
// prettier-ignore
export const MINOR_UNIT_EXCEPTIONS = {"JPY":0,"KRW":0,"CLP":0,"VND":0,"ISK":0,"HUF":0,"TWD":0,"KWD":3,"BHD":3,"OMR":3,"JOD":3};
// prettier-ignore
export const SYMBOLS = {"USD":"$","GBP":"£","EUR":"€","CAD":"CA$","AUD":"A$","NZD":"NZ$"};
